export default __webpack_public_path__ + "static/media/FAC1.2a02dc25.jpg";